document.addEventListener('DOMContentLoaded', function() {
  const swatches = document.querySelectorAll('.swatch-option-item');

  swatches.forEach(swatch => {
    swatch.addEventListener('click', function() {
      const value = this.getAttribute('data-value');
      const variantName = this.closest('.swatch-option-wrapper').querySelector('legend').textContent.trim();
      const variantRadio = document.querySelector(`input[name="${variantName}"][value="${value}"]`);

      if (variantRadio) {
        variantRadio.checked = true;
        variantRadio.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        console.error('Variant radio not found for value:', value);
      }
    });
  });
});